export default "__VITE_ASSET__1f7cbf3e__"